module.exports = { "default": require("core-js/library/fn/math/log1p"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/core-js/math/log1p.js
// module id = 1400
// module chunks = 2